/**
 * Cross-site URLs for the landing page.
 * Override with VITE_APP_URL / VITE_BLOG_URL; empty → localhost in dev, prod hosts in build.
 * Canonical marketing origin is always https://revel.club in production meta (index.html).
 */
function siteOrigin(
  envKey: 'VITE_APP_URL' | 'VITE_BLOG_URL',
  devDefault: string,
  prodDefault: string,
): string {
  const raw = import.meta.env[envKey]
  if (typeof raw === 'string' && raw.trim()) return raw.replace(/\/$/, '')
  return (import.meta.env.DEV ? devDefault : prodDefault).replace(/\/$/, '')
}

export const landingOrigin = 'https://revel.club'

export const appOrigin = siteOrigin(
  'VITE_APP_URL',
  'http://localhost:3050',
  'https://app.revel.club',
)

export const blogOrigin = siteOrigin(
  'VITE_BLOG_URL',
  'http://localhost:3052',
  'https://blog.revel.club',
)

export const urls = {
  landing: landingOrigin,
  app: appOrigin,
  blog: blogOrigin,
  login: `${appOrigin}/login`,
  register: `${appOrigin}/register`,
  terms: `${appOrigin}/terms`,
  privacy: `${appOrigin}/privacy`,
} as const
